/**
 * VerifiedBadge Component
 * Palomita azul estilo Instagram/TikTok/Facebook para tiendas verificadas
 */
import React from 'react';
import { Check } from 'lucide-react';

/**
 * Badge de verificación estilo redes sociales
 * @param {string} size - 'sm' | 'md' | 'lg' (default: 'sm')
 * @param {string} className - Clases adicionales
 */
const VerifiedBadge = ({ size = 'sm', className = '' }) => {
  const sizes = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };
  
  const iconSizes = {
    xs: 'w-2 h-2',
    sm: 'w-2.5 h-2.5',
    md: 'w-3 h-3',
    lg: 'w-3.5 h-3.5'
  };

  return (
    <span 
      className={`inline-flex items-center justify-center rounded-full bg-blue-500 ${sizes[size]} ${className}`}
      title="Tienda verificada"
    >
      <Check className={`${iconSizes[size]} text-white`} strokeWidth={3} />
    </span>
  );
};

/**
 * Nombre de tienda con badge de verificado
 * @param {string} name - Nombre de la tienda
 * @param {boolean} verified - Si la tienda está verificada
 * @param {string} size - 'xs' | 'sm' | 'md' | 'lg'
 * @param {string} className - Clases adicionales para el contenedor
 * @param {string} nameClassName - Clases adicionales para el nombre
 */
export const VerifiedStoreName = ({ 
  name, 
  verified = false, 
  size = 'sm', 
  className = '',
  nameClassName = ''
}) => {
  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      <span className={nameClassName}>{name}</span>
      {verified && <VerifiedBadge size={size} />}
    </span>
  );
};

export default VerifiedBadge;
